var diceImage = "/static/187f6ec771825388.png";

export { diceImage as default };
//# sourceMappingURL=dice.png.js.map
